import { Action, handleActions } from 'redux-actions'
import {
  searchCompanies,
  searchCompaniesSuccess,
  searchCompaniesFail,
  setSuperAdminTargetCompany,
  updateSuperAdminTargetCompanyInfo,
  clearSuperAdminTargetCompany,
} from './SuperAdminActions'

export interface CompanyListItem {
  companyId: string
  companyName: string
  users: number
  employees: number
  active: boolean
  clientStatus: string
  userCreated: boolean
  plan: string
  scope: string
  startAt: string
  paidUntil: string
  createdAt?: string
  reportRequired?: boolean
  reportRequiredForUsers?: boolean
  hideStatisticsView?: boolean
  hideRankingView?: boolean
  divisionRequired?: boolean
  teamSelectionLocked?: boolean
  teamSwitchingDisabled?: boolean
  userCreatedTeams?: boolean
  minTeamSize?: number
  maxTeamSize?: number
}

class State {
  searchResults: CompanyListItem[] = []
  searchQuery: string = ''
  searchLoading: boolean = false
  totalCount: number = 0
  page: number = 0
  targetCompany: CompanyListItem | null = null
}

export const superAdmin = handleActions<State, any>(
  {
    [String(searchCompanies)]: (state: State, action: Action<any>): State => ({
      ...state,
      searchLoading: true,
      searchQuery: action.payload?.query || state.searchQuery,
      page: action.payload?.page ?? state.page,
    }),
    [String(searchCompaniesSuccess)]: (state: State, action: Action<any>): State => ({
      ...state,
      searchLoading: false,
      searchResults: action.payload?.companies || [],
      totalCount: action.payload?.totalCount || 0,
    }),
    [String(searchCompaniesFail)]: (state: State): State => ({
      ...state,
      searchLoading: false,
      searchResults: [],
      totalCount: 0,
    }),
    [String(setSuperAdminTargetCompany)]: (state: State, action: Action<any>): State => ({
      ...state,
      targetCompany: action.payload || null,
    }),
    [String(updateSuperAdminTargetCompanyInfo)]: (state: State, action: Action<any>): State => ({
      ...state,
      targetCompany: state.targetCompany ? { ...state.targetCompany, ...action.payload } : null,
    }),
    [String(clearSuperAdminTargetCompany)]: (state: State): State => ({
      ...state,
      targetCompany: null,
    }),
  },
  new State(),
)

export { State as SuperAdminState }
